import React from 'react';
import { Route } from 'react-router-dom';

import { RouteWithSubRoutesProps } from './types';

/**
 * Component that receives a `RouteConfig` object and knows how to handle sub-routes by passing
 * them to the component it renders.
 */
const RouteWithSubRoutes = ({
  component: Component,
  exact,
  path,
  routes,
}: RouteWithSubRoutesProps) => (
  <Route exact={exact} path={path}>
    <Component routes={routes} />
  </Route>
);

export { RouteWithSubRoutes };
